import { createNativeStackNavigator } from "@react-navigation/native-stack";
import {
  ChangePasswordRoute,
  ForgotPasswordRoute,
  GettingStartedRoute,
  LoginRoute,
  OrganizationAccessDeniedRoute,
  SignupRoute,
} from "./routes";
import React, { FC } from "react";
import { AuthStackParams } from "./AuthStackParams";
import { GettingStarted, Login, SignUp } from "../../screens";
import ForgotPassword from "../../screens/ForgotPassword";
import OrganizationAccessDenied from "../../screens/OrganizationAccessDenied";
import ChangePassword from "../../screens/Auth/ChangePassword";

const { Navigator, Screen } = createNativeStackNavigator<AuthStackParams>();

interface AuthStackProps {
  initialRoute?: string;
  initialParams?: Record<string, any>;
}

const AuthStack: FC<AuthStackProps> = ({ initialRoute, initialParams }) => (
  <Navigator
    initialRouteName={initialRoute || GettingStartedRoute}
    screenOptions={{
      headerShown: false,
    }}
  >
    <Screen name={GettingStartedRoute} component={GettingStarted} />
    {/* 👇 Allow login to receive initialParams (prefilled username/password) */}
    <Screen
      name={LoginRoute}
      component={Login}
      initialParams={initialParams}
    />
    <Screen name={SignupRoute} component={SignUp} />
    <Screen name={ForgotPasswordRoute} component={ForgotPassword} />
    <Screen
      name={OrganizationAccessDeniedRoute}
      component={OrganizationAccessDenied}
    />
    <Screen name={ChangePasswordRoute} component={ChangePassword} />
  </Navigator>
);

export default AuthStack;